"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Address = _interopRequireDefault(require("./models/Address"));
var _Common = _interopRequireDefault(require("./models/Common"));
var _Counterparty = _interopRequireDefault(require("./models/Counterparty"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}
var NovaPoshta = /*#__PURE__*/
function () {
  function NovaPoshta() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, NovaPoshta);
    var self = this;
    self.apiKey = options.apiKey || '';
    self.endpoint = options.endpoint || 'https://api.novaposhta.ua/v2.0/json/';
    self.logger = options.logger || false;
    self.address = new _Address.default(self);
    self.common = new _Common.default(self);
    self.counterparty = new _Counterparty.default(self);
  }
  _createClass(NovaPoshta, [{
    key: "_log",
    value: function _log(message) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'info';
      if (this.logger) {
        this.logger.log(type, message, params);
      }
    }
  }, {
    key: "_request",
    value: function _request(params) {
      var self = this;
      var args = {
        method: 'POST',
        body: JSON.stringify(Object.assign({}, params, {
          apiKey: self.apiKey
        }))
      };
      return new Promise(function (resolve, reject) {
        var fetchPromise = fetch(self.endpoint, args);
        var onSuccess = function onSuccess(json, data) {
          self._log("NovaPoshta::".concat(params.calledMethod, " request executed"), {
            params: params,
            response: json
          }, 'info');
          resolve(json, data);
        };
        var onError = function onError(error, data) {
          self._log("NovaPoshta::".concat(params.calledMethod, " request failed: ").concat(error), params, 'error');
          reject(error, data);
        };
        fetchPromise.catch(function (error) {
          return onError(error, null);
        });
        fetchPromise.then(function (response) {
          if (response.ok) {
            var jsonPromise = response.json();
            jsonPromise.catch(function (error) {
              return onError(error, null);
            });
            jsonPromise.then(function (json) {
              if (json.success) {
                onSuccess(json, response);
              } else {
                var error = json.errors[0] || 'Unexpected error';
                onError(error, json);
              }
            });
          } else {
            onError(response.statusText, null);
          }
        });
      });
    }
  }]);
  return NovaPoshta;
}();
NovaPoshta.version = '0.2.0';
var _default = NovaPoshta;
exports.default = _default;